import doubleBeefBurger from './Burger/Double Beef Burger.png'
import hotSpicyBurger from './Burger/Hot Spicy Burger.png'

let burgerItems = [
    {
        item_id: "28",
        item_name: "Double Beef Burger",
        item_image:doubleBeefBurger ,
        item_price:"2450",
        item_category: "burger",
      },
      {
        item_id: "29",
        item_name: "Hot Spicy Burger",
        item_image: hotSpicyBurger,
        item_price:"1850",
        item_category: "burger",
      },
]

export default burgerItems